/**
 * Reescribe enlaces del carrito (drawer + página) al PDP canónico cuando Liquid expuso
 * data-farmex-original-shopify-id (tag solo numérico con id Shopify del original).
 * Resolución: suggest.json por SKU; se elige el producto con id coincidente y, si hay
 * variantes con ese SKU, se añade ?variant=...
 */
(function () {
  const rootPrefix = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function cleanProductUrl(raw) {
    if (!raw || typeof raw !== 'string') return raw;
    try {
      const abs = raw.startsWith('http') ? raw : `${window.location.origin}${raw.startsWith('/') ? '' : '/'}${raw}`;
      const u = new URL(abs);
      ['_pos', '_psq', '_ss', '_v'].forEach((k) => u.searchParams.delete(k));
      const q = u.searchParams.toString();
      return u.pathname + (q ? `?${q}` : '');
    } catch {
      return raw.split('?')[0] || raw;
    }
  }

  function productUrlWithSkuVariant(product, sku) {
    if (!product || !product.url) return null;
    let path = product.url;
    const skuNorm = String(sku || '').trim();
    const variants = product.variants || [];
    if (skuNorm && variants.length) {
      const hit = variants.find((v) => String(v.sku || '').trim() === skuNorm);
      if (hit && hit.id) {
        const sep = path.includes('?') ? '&' : '?';
        path = `${path}${sep}variant=${hit.id}`;
      }
    }
    return path;
  }

  async function fetchProductByIdViaSku(productId, sku) {
    if (!productId || Number.isNaN(productId) || !sku) return null;
    const url = `${rootPrefix}search/suggest.json?q=${encodeURIComponent(sku)}&resources[type]=product&resources[options][fields]=variants.sku&resources[limit]=10`;
    const res = await fetch(url);
    if (!res.ok) return null;
    const data = await res.json();
    const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    return products.find((p) => String(p.id) === String(productId)) || null;
  }

  function applyResolvedUrl(scopeEl, rawUrl) {
    const next = cleanProductUrl(rawUrl);
    if (!next) return;

    scopeEl.querySelectorAll('a[href*="/products/"]').forEach((a) => {
      a.setAttribute('href', next);
    });
    scopeEl.querySelectorAll('a[data-href*="/products/"]').forEach((a) => {
      a.setAttribute('data-href', next);
    });
    scopeEl.querySelectorAll('[data-product-url*="/products/"]').forEach((node) => {
      node.setAttribute('data-product-url', next);
    });
    scopeEl.querySelectorAll('[data-url*="/products/"]').forEach((node) => {
      node.setAttribute('data-url', next);
    });
  }

  async function hydrateElement(el) {
    if (el.getAttribute('data-farmex-original-resolved') === '1') return;

    const idStr = (el.getAttribute('data-farmex-original-shopify-id') || '').trim();
    const sku = (el.getAttribute('data-farmex-resolve-sku') || '').trim();
    const id = parseInt(idStr, 10);
    if (!idStr || Number.isNaN(id)) {
      el.setAttribute('data-farmex-original-resolved', '1');
      return;
    }

    try {
      const match = await fetchProductByIdViaSku(id, sku);
      if (match) {
        const resolved = productUrlWithSkuVariant(match, sku) || match.url;
        if (resolved) applyResolvedUrl(el, resolved);
      }
    } catch (e) {
      console.warn('[farmex-original-product-link]', e);
    }
    el.setAttribute('data-farmex-original-resolved', '1');
  }

  function hydrateAll(root) {
    const base = root && root.nodeType ? root : document;
    const nodes = base.querySelectorAll('[data-farmex-original-shopify-id]:not([data-farmex-original-resolved="1"])');
    return Promise.all(Array.from(nodes).map((el) => hydrateElement(el)));
  }

  function scheduleHydrate(root) {
    queueMicrotask(() => {
      hydrateAll(root || document);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    hydrateAll(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event && event.target) hydrateAll(event.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      scheduleHydrate(document);
    });
  }
})();
